import React, {ReactNode} from "react";
import {BuildingRequirement as BuildingRequirementType} from "../../../index";
import {BuildingRequirementBuilding} from "./BuildingRequirementBuilding";
import {BuildingRequirementTribe} from "./BuildingRequirementTribe";
import {BuildingRequirementNotBuilding} from "./BuildingRequirementNotBuilding";
import ImageBuilding from "../../ImageBuilding/ImageBuilding";
import {useTranslationContext} from "../../../../react/providers/TranslationContext";

type Props = {
    requirement: BuildingRequirementType,
    setSelectedBuilding?: (gid: number|null) => void,
}

export default function BuildingRequirement({ requirement, setSelectedBuilding }: Props) {
    const { translate } = useTranslationContext();

    switch (requirement.type) {
        case 'Building': return <BuildingRequirementBuilding gid={requirement.gid} level={requirement.level} setSelectedBuilding={setSelectedBuilding} />;
        case 'NotBuilding': return <BuildingRequirementNotBuilding gid={requirement.gid} setSelectedBuilding={setSelectedBuilding} />
        case 'Tribe': return <BuildingRequirementTribe vid={requirement.vid} />;
        case 'Capital': return <BuildingRequirementSimple text={translate('req_Capital')} icon={<ImageBuilding gid={26} size={24} />} />;
        case 'NotCapital': return <BuildingRequirementSimple text={translate('req_NotCapital')} icon={<ImageBuilding gid={26} size={24} grayscale={true} />} />;
        case 'City': return <BuildingRequirementSimple text={translate('req_City')} icon={<ImageBuilding gid={24} size={24} />} />;
        case 'Shore': return <BuildingRequirementSimple text={translate('req_Shore')} icon={<ImageBuilding gid={49} size={24} />} />;
        case 'StorageArtefact': return <BuildingRequirementSimple text={translate('req_StorageArtefact')} icon={<ImageBuilding gid={27} size={24} />} />;
        case 'UniqueInAccount': return <div>{translate('req_UniqueInAccount')}</div>; // No translations for it :(
        case 'WonderOfTheWorldVillage': return <BuildingRequirementSimple text={translate('req_WonderOfTheWorldVillage')} icon={<ImageBuilding gid={40} size={24} />} />;
        case 'Level11CapitalOrCity': return <div>{translate('level') + ' 11+: ' + translate('req_CapitalOrCity')}</div>;
        case 'Level13Capital': return <div>{translate('level') + ' 13+: ' + translate('req_Capital')}</div>;
    }
}

function BuildingRequirementSimple({ text, icon }: { text: string, icon: ReactNode }) {
    return <div className='d-flex align-items-center gap-2'>
        {icon}
        <div>{text}</div>
    </div>
}
